// @ts-check
import { registerPlugin } from "@mailonline/dmg-ads-core/src/plugin-registry";

const DEFAULT = { refreshCount: 0 }

registerPlugin('refreshInfo', {
  ccpa: { enabledIfDissent: true },
  gdpr: { enabledIfDissent: true },

  run({ broker, log }) {
    const state = {}

    broker.intercept('slot defined', ([msg, { pos }], next) => {
      state[pos] = typeof state[pos] !== 'undefined' ? { ...state[pos], refreshCount: state[pos].refreshCount + 1 } : DEFAULT
      next()
    })

    broker.on('destroy slot', pos => {
      broker.emit('reset refresh info for pos', pos)
    })

    broker.on('reset refresh info for pos', pos => {
      delete state[pos]
    })

    broker.register('get tags', ({ slot: { pos } }) => [state[pos]])

    broker.register('get video tags', ({ slot: { pos } }) => {
      return { cust_params: { ...(state[pos] || DEFAULT) } }
    })

    broker.intercept('refresh ads', ([msg, pos, { positions, plugins, reason: refreshReason }], next) => {
      try {
        positions.forEach(pos => {
          state[pos] = {
            refresh: true,
            refreshCount: state[pos].refreshCount + 1,
            refreshReason
          }
        })
      } finally {
        next()
      }
    })
  }
})
